import * as React from "react";
import { useReducer, useEffect } from "react";
import { Row, Col, Button, Input, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import GenericDropdown from './controls/GenericDropdown';
import { LookupItem } from "../Models/LookupItem";
import * as Utils from '../Utils';
import SavingsBenefitsListingResults, { SearchFilterSavingsBenefits } from "./SavingsBenefitsListingResult";
import { SavingsBenefitsItem } from "../Models/SavingsBenefitsItem";
import FeaturedSavingsBenefits from "./FeaturedSavingsBenefits";
import { SpotlightItem } from "./Spotlight";
import Spotlight from "./Spotlight";
import CheckboxList from "./controls/CheckboxList";

type OrderBy = 'date' | 'alpha';

type SavingsBenefitsListingState = {
    keywords: string;
    selectedCategories: LookupItem[];
    selectedLocations: LookupItem[];
    selectedOrganizations: LookupItem[];
    selectedTags: LookupItem[];
    //selectedYearMonth: LookupItem;
    searchFilterSavingsBenefits: SearchFilterSavingsBenefits;
    //orderBy: OrderBy;
    initDone: boolean;
}

const initialState: SavingsBenefitsListingState = {
    keywords: '',
    selectedCategories: [],
    selectedLocations: [],
    selectedOrganizations: [],
    selectedTags: [],
    //selectedYearMonth: undefined,
    searchFilterSavingsBenefits: undefined,
    //orderBy: 'date',
    initDone: false
}

const SavingsBenefitsListing = (props: {
    Path: string;
    SavingsBenefits: LookupItem[];
    Categories: LookupItem[];
    Locations: LookupItem[];
    Organizations: LookupItem[];
    Tags: LookupItem[];
    BackgroundImage: string;
    Title: string;
    FeaturedArticle: SavingsBenefitsItem;
    Spotlights: SpotlightItem[];
    PreselectedSavingsBenefitsValue?: string;
    HeaderHtml?: string;
    BreadcrumHtml?: string;
    IsLive: boolean;
    ClearSearchUrl: string;
    DisclaimerMessage: string;
}) => {

    let [state, setState] = useReducer(
        (prevState: SavingsBenefitsListingState, SavingsBenefitsstate: Partial<SavingsBenefitsListingState>) => ({ ...prevState, ...SavingsBenefitsstate }),
        initialState
    );

    const search = () => {
        const sf: SearchFilterSavingsBenefits = {
            Categories: (state.selectedCategories || []).map(x => x.Value),
            Locations: (state.selectedLocations || []).map(x => x.Value),
            Organizations: (state.selectedOrganizations || []).map(x => x.Value),
            Tags: (state.selectedTags || []).map(x => x.Value),
            Keywords: state.keywords,
            SortByField: "date",
            Path: props.Path
        };
       
        setState({ searchFilterSavingsBenefits: sf });
    };

    const searchByCategory = (categoryId: string) => {

        let category = props.SavingsBenefits.find(x => x.Value == categoryId);
    }

    const clearFilters = () => {
        if (props.ClearSearchUrl) {
            window.location.href = props.ClearSearchUrl;
        }

        let sf: SearchFilterSavingsBenefits = {
            Categories: [],
            Locations: [],
            Organizations: [],
            Tags: [],
            Keywords: '',
            SortByField: "date",            
            Path: props.Path
        };

        setState({
            keywords: '',
            selectedCategories: [],
            selectedLocations: props.Locations,
            selectedOrganizations: [],
            selectedTags: [],
            searchFilterSavingsBenefits: sf
        });
    }


    useEffect(() => {

        let hp: HashParams = {
            cat: state.selectedCategories.map(x => x.Title).join('|'),            
            loc: state.selectedLocations.map(x => x.Title).join('|'),  
            org: state.selectedOrganizations.map(x => x.Title).join('|'),  
            tag: state.selectedTags.map(x => x.Title).join('|'),
            q: state.keywords
        };

        if (state.initDone) {
            window.location.href = Utils.buildHash(hp);
        }

    }, [state.searchFilterSavingsBenefits]);

    useEffect(() => {

        let newState: Partial<SavingsBenefitsListingState> = {};

        /*if (props.PreselectedSavingsBenefitsValue && props.PreselectedSavingsBenefitsValue.length > 0) {
            var savingsBenefits = props.SavingsBenefits.find(x => x.Value.toLowerCase() == props.PreselectedSavingsBenefitsValue.toLowerCase());
            let updatedValues = [];
            if (savingsBenefits) {
                let item = props.Categories.find(y => y.Title.toLowerCase() == savingsBenefits.Title.toLowerCase());
                if (item) {
                    newState.selectedCategories = updatedValues.concat([item]);
                }
            }
        }*/

        newState.selectedLocations = props.Locations;
        if (location.hash && location.hash.length > 2) {
            let urlParams = Utils.hashStringParse(location.hash) as HashParams;

             // set category
            if (urlParams.cat) {
                newState.selectedCategories = urlParams.cat.split('|').map(x => props.Categories.find(y => y.Title.toLowerCase() == x.toLowerCase()));
            }

            // set keyword
            if (urlParams.q && urlParams.q.length > 0) {
                newState.keywords = urlParams.q;
            }

            // set location
            if (urlParams.loc && urlParams.loc.length > 0) {
                newState.selectedLocations = urlParams.loc.split('|').map(x => props.Locations.find(y => y.Title.toLowerCase() == x.toLowerCase()));
            }

            // set organization
            if (urlParams.org && urlParams.org.length > 0) {
                newState.selectedOrganizations = urlParams.org.split('|').map(x => props.Organizations.find(y => y.Title.toLowerCase() == x.toLowerCase()));
            }

            // set tag
            if (urlParams.tag && urlParams.tag.length > 0) {
                newState.selectedTags = urlParams.tag.split('|').map(x => props.Tags.find(y => y.Title.toLowerCase() == x.toLowerCase()));
            }
        }

        newState.initDone = true;
        //newState.orderBy = 'date';

        newState.searchFilterSavingsBenefits = {
            Categories: (newState.selectedCategories || []).map(x => x.Value),
            Locations: (newState.selectedLocations || []).map(x => x.Value),
            Organizations: (newState.selectedOrganizations || []).map(x => x.Value),
            Tags: (newState.selectedTags || []).map(x => x.Value),
            Keywords: newState.keywords,
            SortByField: "date",
            Path: props.Path
        };

        console.log("props.Path");
        console.log(props.Path);
        setState(newState);

    }, []);

    // return
    return <div className="chapters-listing">
        <div className="full-width-content p-0">
            <div className="page-section py-0">
                <div className="chapter-filters-wrapper savings-filters-wrapper" style={{ backgroundImage: `url(${props.BackgroundImage})` }}>
                    <h1 className="title">{props.Title}</h1>
                    <div className="saving-benefits inline-filters d-flex flex-lg-row flex-column flex-md-column">
                        <div className="d-lg-flex w-100">

                            <UncontrolledDropdown>
                                <DropdownToggle caret>
                                    All Categories
                                </DropdownToggle>
                                <DropdownMenu>
                                    <CheckboxList
                                        dataSource={props.Categories}
                                        getId={x => x.Value}
                                        renderItem={x => x.Title}
                                        selectedValues={state.selectedCategories.map(x => x.Value) || []}
                                        onSelectedItemChanged={(item, checked) => {

                                            let updatedValues = [];

                                            if (checked) {
                                                updatedValues = state.selectedCategories.concat([item]);
                                            } else {
                                                updatedValues = state.selectedCategories.filter(x => x.Value != item.Value);
                                            }

                                            setState({ selectedCategories: updatedValues });
                                        }}
                                    />
                                </DropdownMenu>
                            </UncontrolledDropdown >
                            <UncontrolledDropdown>
                                <DropdownToggle caret>
                                    All Locations
                                </DropdownToggle>
                                <DropdownMenu>
                                    <CheckboxList
                                        dataSource={props.Locations}
                                        getId={x => x.Value}
                                        renderItem={x => x.Title}
                                        selectedValues={state.selectedLocations.map(x => x.Value) || []}
                                        onSelectedItemChanged={(item, checked) => {
                                            let updatedValues = [];

                                            if (checked) {
                                                updatedValues = state.selectedLocations.concat([item]);
                                            } else {
                                                updatedValues = state.selectedLocations.filter(x => x.Value != item.Value);
                                            }

                                            setState({ selectedLocations: updatedValues });
                                        }}
                                    />
                                </DropdownMenu>
                            </UncontrolledDropdown >
                            <UncontrolledDropdown>
                                <DropdownToggle caret>
                                    All Organizations
                                </DropdownToggle>
                                <DropdownMenu>
                                    <CheckboxList
                                        dataSource={props.Organizations}
                                        getId={x => x.Value}
                                        renderItem={x => x.Title}
                                        selectedValues={state.selectedOrganizations.map(x => x.Value) || []}
                                        onSelectedItemChanged={(item, checked) => {

                                            let updatedValues = [];

                                            if (checked) {
                                                updatedValues = state.selectedOrganizations.concat([item]);
                                            } else {
                                                updatedValues = state.selectedOrganizations.filter(x => x.Value != item.Value);
                                            }

                                            setState({ selectedOrganizations: updatedValues });
                                        }}
                                    />
                                </DropdownMenu>
                            </UncontrolledDropdown >

                            <UncontrolledDropdown>
                                <DropdownToggle caret>
                                    All Collections
                                </DropdownToggle>
                                <DropdownMenu>
                                    <CheckboxList
                                        dataSource={props.Tags}
                                        getId={x => x.Value}
                                        renderItem={x => x.Title}
                                        selectedValues={state.selectedTags.map(x => x.Value) || []}
                                        onSelectedItemChanged={(item, checked) => {

                                            let updatedValues = [];

                                            if (checked) {
                                                updatedValues = state.selectedTags.concat([item]);
                                            } else {
                                                updatedValues = state.selectedTags.filter(x => x.Value != item.Value);
                                            }

                                            setState({ selectedTags: updatedValues });
                                        }}
                                    />
                                </DropdownMenu>
                            </UncontrolledDropdown >

                            <div className="search" style={{ maxWidth: "45%" }}>                                
                                <div className="input-group w-100">
                                    <div className="search-icon">
                                        <i className="fas fa-search"></i>
                                    </div>
                                    <Input onChange={(e) => { setState({ keywords: e.target.value }) }}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                search();
                                            }
                                        }}
                                        value={state.keywords}
                                        className="form-control"
                                        placeholder="Search for keywords and description" />

                                    <Button onClick={search}>Search</Button>
                                    <Button onClick={clearFilters} className="btn-clear">Clear Search</Button>
                                </div>                              
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
                {props.HeaderHtml && <div dangerouslySetInnerHTML={{ __html: props.HeaderHtml }}></div>}
            </div>
        </div>
        <div className="full-width-content pt-0">
            <div className="page-section pt-0">
                <div className="page-section-inner">
                    <Row>
                        <Col md={9}>
                            {props.BreadcrumHtml
                                && <div dangerouslySetInnerHTML={{ __html: props.BreadcrumHtml }}></div>}
                            <SavingsBenefitsListingResults
                                searchFilter={state.searchFilterSavingsBenefits}
                                searchByCategory={searchByCategory}
                                isLive={props.IsLive}
                                DisclaimerMessage={props.DisclaimerMessage}
                            />
                        </Col>
                        <Col md={3} className="pt-30">
                            {props.DisclaimerMessage && <div className="disclaimer-message d-none d-md-block" dangerouslySetInnerHTML={{ __html: props.DisclaimerMessage }}></div>}
                            {props.FeaturedArticle && <FeaturedSavingsBenefits item={props.FeaturedArticle} />}
                            {(props.Spotlights || []).map((x, index) => <Spotlight item={x} key={index} />)}
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    </div>

}

export class HashParams {    
    cat: string;
    loc: string;
    org: string;
    tag: string;
    q: string;
}

export default SavingsBenefitsListing;